<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Note#uglDW5TMEBazcF9VZGxHvYD">Note</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Ack#u49OgEGmahNfkAXxyKZ7ha3">Acknowledgments</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Preface#uvJtDlmVXGUakh45y2aiSTE">Preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_01#u4zoQDQRnQ8rS44kuKdA6L9">1: The Scoop</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_02#uG9PqKWlCtTLGKCErYq38IF">2: Michigan’s Crown Jewel</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chapter_03#uaj5dR4JgWMgxKcnBiKmW8F">3: Frances</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_04#uWEexKqwZbgzupbK92g5MC9" title="Link target outside of Sample">4: Missing</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_05#ukDdIuBhGQMUNj8jtsUmjcD" title="Link target outside of Sample">5: The Search Begins</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_06#uFbpXEA6Xx6Zo8pAnXgPYI5" title="Link target outside of Sample">6: Paul Strantz</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_07#u3pkAOs4wkbRTGSmY3dxOQ8" title="Link target outside of Sample">7: First Clues</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_08#u878ozK4WDajo7HZwcX7rk3" title="Link target outside of Sample">8: Grim Paradise</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_09#uSRYHn5PYQturVtplYwEFeC" title="Link target outside of Sample">9: Postmortem</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_10#u9RtFSxPWlcSX9RhaEpYrV4" title="Link target outside of Sample">10: The Hunt</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_11#uzjHsM335FVxdcWqHqFpDQG" title="Link target outside of Sample">11: Moral Re-armament</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_12#umcMd4Qx9oOFrw8IIqSEbn4" title="Link target outside of Sample">12: Expanding The Search</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_13#uEqy6UIdegCa2ZcpHjURyG8" title="Link target outside of Sample">13: Hurried Getaway</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_14#u6xbzevHr8QUsSF6sgNWfw2" title="Link target outside of Sample">14: Harold Asp</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_15#u4Jg4pKzRlrFRQEwaTDCs9H" title="Link target outside of Sample">15: The Billfold</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_16#upuDCzmQt6n6Uu8FGlRW2gF" title="Link target outside of Sample">Photos</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_17#uTgQtUtjmKTK4VvL5FzOGmG" title="Link target outside of Sample">16: Trace Evidence</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_18#uElwe7KjLsoB4kZMejVtgF9" title="Link target outside of Sample">17: Mrs. DeCourval</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_19#ub3Cu8rT8RnTZpBEam7SGuA" title="Link target outside of Sample">18: New Tips</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_20#uCItdcj7gtiUhmgNobBXGFE" title="Link target outside of Sample">19: Stalled</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_21#uf3fwqMvGiDMvnTwgg2bEvA" title="Link target outside of Sample">20: Starved Rock</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_22#u39SmgR763zgESTkJcMbIO6" title="Link target outside of Sample">21: Tiny</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_23#ukLuTiD4oGapfSZNcQNSLv4" title="Link target outside of Sample">22: Murder in Minnesota</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_24#utKSC2e3TYallXIZXlvbQK9" title="Link target outside of Sample">23: The Jungfrau</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_25#ubbI937RXctGPMEx3nymKg8" title="Link target outside of Sample">24: Fisher</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_26#uVXnkXsFXjrtiDp9kBnF8C4" title="Link target outside of Sample">25: The Thompson Murder</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_27#uSxOOQF5lJabhqZT2XkP4LB" title="Link target outside of Sample">26: Paul Strantz Returns</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_28#uuiv7IaVVLECvGIqjwjZlD6" title="Link target outside of Sample">27: Long-Term Storage</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_29#uRHYM3kiXHlUqW8fcgeldH8" title="Link target outside of Sample">28: Profiles</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_30#uMm9eHy4jfuZ7hZWExclbDC" title="Link target outside of Sample">29: Lost</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chapter_31#uz4bV4UuAbvWFBOOqJX8ca3" title="Link target outside of Sample">30: A New Person of Interest</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Afterword#ut4qqTXDKy7yBYcl5q2oC58" title="Link target outside of Sample">Afterword</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Biblio#uiqMzXnxDxAoZYnTGLSMPi3" title="Link target outside of Sample">Bibliography</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?68ea80b4